(function () {
  'use strict';
  if (window.__qCartFetchPatch) return;
  window.__qCartFetchPatch = true;

  var origFetch = window.fetch;
  if (typeof origFetch !== 'function') return;

  function qSleep(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  /* Retry transient gateway errors only. Do NOT retry 429 — retries amplify Cloudflare rate limits. */
  function qShouldRetry(status) {
    return status === 503 || status === 502 || status === 504;
  }

  function qRetryFetch(input, init, retriesLeft) {
    var remaining = retriesLeft == null ? 1 : retriesLeft;
    return origFetch.call(window, input, init)
      .then(function (res) {
        if (qShouldRetry(res.status) && remaining > 0) {
          return qSleep(1200).then(function () {
            return qRetryFetch(input, init, remaining - 1);
          });
        }
        return res;
      })
      .catch(function (err) {
        if (remaining > 0) {
          return qSleep(1200).then(function () {
            return qRetryFetch(input, init, remaining - 1);
          });
        }
        throw err;
      });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
    if (url.indexOf('/cart/') !== -1) {
      return qRetryFetch(input, init, 1);
    }
    return origFetch.apply(this, arguments);
  };
})();
